import GeneralServices from "./GeneralServices";

class WASISAServices {

  getPetBreeds = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `wasisa/breeds${args.params ? '?' + args.params.join("&") : ''}`,
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }

  getProfessions = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `wasisa/professions${args.businessLine ? '?businessLine=' + args.businessLine : ''}`,
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }
  
}

export default new WASISAServices();